import { gql } from 'graphql-request';

export const emailLoginMutation = gql`
  mutation login($username: String!, $password: String!) {
    login(credential: { username: $username, password: $password }) {
      access
      refresh
    }
  }
`;

export const googleLoginMutation = gql`
  mutation googleLogin($authCode: String!, $redirectUri: String!) {
    googleLogin(authCode: $authCode, redirectUri: $redirectUri) {
      access
      refresh
    }
  }
`;
export const firebaseLoginMutation = gql`
  mutation firebaseLoginByUid($uid: String!) {
    firebaseLoginByUid(uid: $uid) {
      access
      refresh
    }
  }
`;
